import React from "react";
import { Tab } from "semantic-ui-react";
import GeslabAlert from "../../GesLab";

const GeslabWarningContent = ({ data, patchGeslabAlert }) => {
	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			<GeslabAlert folder={data.folders[0]} submit={(values) => patchGeslabAlert(data.folders[0].id, values)} disabled={data.isDone} />
		</Tab.Pane>
	);
};
export default GeslabWarningContent;
